import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';
import { ReactNode, HTMLAttributes } from 'react';
import { AnimateHeightProps } from '../AnimateHeight/animateHeight.types';

export enum AccordionIconSizeTypes {
  SM = 'sm',
  LG = 'lg',
}

export enum AccordionIconTypeTypes {
  STANDARD = 'standard',
  CIRCULAR = 'circular',
}

export enum AccordionIconThemeTypes {
  DARK = 'dark',
  LIGHT = 'light',
}

/** Interfaces */
export interface SizeMap {
  [size: string]: number;
}

export interface IconTypes extends DefaultProps {
  iconSize?: AccordionIconSizeTypes;
  iconType?: AccordionIconTypeTypes;
  iconTheme?: AccordionIconThemeTypes;
  showIcon?: boolean;
}

export interface IconWrapperType extends IconTypes {
  iconRotated?: boolean;
}

export interface AnimationProps extends AnimateHeightProps {
  animate?: boolean;
}

export interface AccordionItemProps extends DefaultProps, IconTypes {
  headline: string;
  children?: ReactNode;
  contentId: string;
  initOpen?: boolean;
  handlers?: Handler;
  render?: (f: (p: string) => void) => ReactNode;
  isOpen?: boolean;
  subHeaderText?: string;
  persistSubHeader?: boolean;
  animationOptions?: AnimationProps;
}

export interface ContentType extends DefaultProps, HTMLAttributes<HTMLElement> {
  isAccordionOpened: boolean;
  animate?: boolean;
}
